/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = ({
  name: 'ErrorPage',
  props: {
    type: {
      type: Number,
      default: 500
    }
  },
  data () {
    return {
      ephemeral: {
        isOnline: null // show 'Retry' button only when the browser is online
      }
    }
  },
  methods: {
    onlineHandler () {
      this.ephemeral.isOnline = true
    },
    offlineHandler () {
      this.ephemeral.isOnline = false
    },
    onRetryClick () {
      window.location.reload()
    }
  },
  mounted () {
    if (navigator.onLine === true) {
      this.onlineHandler()
    }

    window.addEventListener('online', this.onlineHandler)
    window.addEventListener('offline', this.offlineHandler)
  },
  beforeDestroy () {
    window.removeEventListener('online', this.onlineHandler)
    window.removeEventListener('offline', this.offlineHandler)
  }
}        )

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type === 500
    ? _c(
        "div",
        { staticClass: "p-wrapper" },
        [
          _c("h1", { staticClass: "is-title-1 p-title" }, [_vm._v("500")]),
          _c(
            "i18n",
            { staticClass: "is-title-3 c-title", attrs: { tag: "h2" } },
            [_vm._v("Server error")]
          ),
          _c("i18n", { staticClass: "c-text", attrs: { tag: "p" } }, [
            _vm._v("We are having some trouble. Please try again later."),
          ]),
          _vm.ephemeral.isOnline
            ? _c(
                "i18n",
                {
                  staticClass: "is-outlined is-small c-retry-btn",
                  attrs: { tag: "button" },
                  on: { click: _vm.onRetryClick },
                },
                [_vm._v("Retry")]
              )
            : _vm._e(),
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "p-wrapper" },
        [
          _c("h1", { staticClass: "is-title-1 p-title" }, [_vm._v("404")]),
          _c(
            "i18n",
            { staticClass: "is-title-3 c-title", attrs: { tag: "h2" } },
            [_vm._v("Page not found")]
          ),
          _c("i18n", { staticClass: "c-text", attrs: { tag: "p" } }, [
            _vm._v("We couldn’t find what you are looking for."),
          ]),
          _c(
            "router-link",
            { staticClass: "button", attrs: { to: "/" } },
            [_c("i18n", [_vm._v("Take me home")])],
            1
          ),
        ],
        1
      )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-8c10a702_0", { source: ".p-wrapper[data-v-8c10a702] {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n}\n.c-title[data-v-8c10a702] {\n  margin-bottom: 0.5rem;\n}\n.c-text[data-v-8c10a702] {\n  color: var(--text_1);\n}\n.c-text + .button[data-v-8c10a702] {\n  align-self: center;\n  margin-top: 2rem;\n}\n.c-retry-btn[data-v-8c10a702] {\n  width: max-content;\n}\n\n/*# sourceMappingURL=ErrorPage.vue.map */", map: {"version":3,"sources":["frontend/views/containers/loading-error/ErrorPage.vue","ErrorPage.vue"],"names":[],"mappings":"AAgEA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AC/DA;ADkEA;EACA,qBAAA;AC/DA;ADkEA;EACA,oBAAA;AC/DA;ADiEA;EACA,kBAAA;EACA,gBAAA;AC/DA;ADmEA;EACA,kBAAA;AChEA;;AAEA,wCAAwC","file":"ErrorPage.vue","sourcesContent":["<template lang='pug'>\n.p-wrapper(v-if='type===500')\n  h1.is-title-1.p-title 500\n  i18n.is-title-3.c-title(tag='h2') Server error\n  i18n.c-text(tag='p') We are having some trouble. Please try again later.\n  i18n.is-outlined.is-small.c-retry-btn(\n    v-if='ephemeral.isOnline'\n    tag='button'\n    @click='onRetryClick'\n  ) Retry\n\n.p-wrapper(v-else)\n  h1.is-title-1.p-title 404\n  i18n.is-title-3.c-title(tag='h2') Page not found\n  i18n.c-text(tag='p') We couldn’t find what you are looking for.\n  router-link.button(to='/')\n    i18n Take me home\n</template>\n\n<script>\nexport default ({\n  name: 'ErrorPage',\n  props: {\n    type: {\n      type: Number,\n      default: 500\n    }\n  },\n  data () {\n    return {\n      ephemeral: {\n        isOnline: null // show 'Retry' button only when the browser is online\n      }\n    }\n  },\n  methods: {\n    onlineHandler () {\n      this.ephemeral.isOnline = true\n    },\n    offlineHandler () {\n      this.ephemeral.isOnline = false\n    },\n    onRetryClick () {\n      window.location.reload()\n    }\n  },\n  mounted () {\n    if (navigator.onLine === true) {\n      this.onlineHandler()\n    }\n\n    window.addEventListener('online', this.onlineHandler)\n    window.addEventListener('offline', this.offlineHandler)\n  },\n  beforeDestroy () {\n    window.removeEventListener('online', this.onlineHandler)\n    window.removeEventListener('offline', this.offlineHandler)\n  }\n}: Object)\n</script>\n\n<style lang=\"scss\" scoped>\n@import \"../../../../frontend/assets/style/_variables.scss\";\n\n.p-wrapper {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n}\n\n.c-title {\n  margin-bottom: 0.5rem;\n}\n\n.c-text {\n  color: $text_1;\n\n  & + .button {\n    align-self: center;\n    margin-top: 2rem;\n  }\n}\n\n.c-retry-btn {\n  width: max-content;\n}\n</style>\n",".p-wrapper {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n}\n\n.c-title {\n  margin-bottom: 0.5rem;\n}\n\n.c-text {\n  color: var(--text_1);\n}\n.c-text + .button {\n  align-self: center;\n  margin-top: 2rem;\n}\n\n.c-retry-btn {\n  width: max-content;\n}\n\n/*# sourceMappingURL=ErrorPage.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-8c10a702"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "<template lang='pug'>\n.p-wrapper(v-if='type===500')\n  h1.is-title-1.p-title 500\n  i18n.is-title-3.c-title(tag='h2') Server error\n  i18n.c-text(tag='p') We are having some trouble. Please try again later.\n  i18n.is-outlined.is-small.c-retry-btn(\n    v-if='ephemeral.isOnline'\n    tag='button'\n    @click='onRetryClick'\n  ) Retry\n\n.p-wrapper(v-else)\n  h1.is-title-1.p-title 404\n  i18n.is-title-3.c-title(tag='h2') Page not found\n  i18n.c-text(tag='p') We couldn’t find what you are looking for.\n  router-link.button(to='/')\n    i18n Take me home\n</template>\n\n<script>\nexport default ({\n  name: 'ErrorPage',\n  props: {\n    type: {\n      type: Number,\n      default: 500\n    }\n  },\n  data () {\n    return {\n      ephemeral: {\n        isOnline: null // show 'Retry' button only when the browser is online\n      }\n    }\n  },\n  methods: {\n    onlineHandler () {\n      this.ephemeral.isOnline = true\n    },\n    offlineHandler () {\n      this.ephemeral.isOnline = false\n    },\n    onRetryClick () {\n      window.location.reload()\n    }\n  },\n  mounted () {\n    if (navigator.onLine === true) {\n      this.onlineHandler()\n    }\n\n    window.addEventListener('online', this.onlineHandler)\n    window.addEventListener('offline', this.offlineHandler)\n  },\n  beforeDestroy () {\n    window.removeEventListener('online', this.onlineHandler)\n    window.removeEventListener('offline', this.offlineHandler)\n  }\n}: Object)\n</script>\n\n<style lang=\"scss\" scoped>\n@import \"../../../../frontend/assets/style/_variables.scss\";\n\n.p-wrapper {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n}\n\n.c-title {\n  margin-bottom: 0.5rem;\n}\n\n.c-text {\n  color: $text_1;\n\n  & + .button {\n    align-self: center;\n    margin-top: 2rem;\n  }\n}\n\n.c-retry-btn {\n  width: max-content;\n}\n</style>\n"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__